import { ReactNode, useMemo } from "react";
import { AdminFormFieldSubmit, AdminFormFieldSubmitProps } from "./formFields";

export type FormActionButton = {
  customWrapperClass?: string;
  buttonDimensionClass?: string;
  label: string | ReactNode;
  type?: AdminFormFieldSubmitProps["type"];
  variant?: AdminFormFieldSubmitProps["variant"];
  onClick?: () => void;
  disabled?: boolean;
};

type FormActionButtonsProps = {
  buttons: FormActionButton[];
};

const FormActionButtons = ({ buttons }: FormActionButtonsProps) => {
  const MemoizedFormActionButtons = useMemo(() => {
    return (
      <>
        {buttons.map((button, index) => (
          <AdminFormFieldSubmit
            customWrapperClass={button.customWrapperClass}
            buttonDimensionClass={button.buttonDimensionClass}
            key={`form_action_button_${index}`}
            label={button.label}
            type={button.type || "submit"}
            variant={button.variant || "secondary"}
            onClick={button.onClick}
            disabled={button.disabled || false}
          />
        ))}
      </>
    );
  }, [buttons]);

  return MemoizedFormActionButtons;
};
export default FormActionButtons;
